import { render } from "./PostCardToolBar.vue?vue&type=template&id=2adbdef6&scoped=true"
import script from "./PostCardToolBar.vue?vue&type=script&lang=js"
export * from "./PostCardToolBar.vue?vue&type=script&lang=js"

import "./PostCardToolBar.vue?vue&type=style&index=0&id=2adbdef6&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2adbdef6"]])

export default __exports__